import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../../util/apiClient";
import EditForm from "../Module/EditForm";
import Formulaire from "./Formulaire";
import {
  addSousModuleDroits,
  editSousModuleDroit,
  setObjSousModuleDroit,
  setOpenDialog,
  setValueEdit,
  setValueComboEdit,
} from "./sousModuleDroitSlice";
import MyDialogComponent from "../../../../components/Common/MyDialogComponent";
import CommonAlert from "../../../../components/Common/CommonAlert";

const AddSousModuleDroit = () => {
  //redux
  const dispatch = useDispatch();
  const { objModuleDroit, moduleDroits } = useSelector((state: IReduxState) => state.modulesDroit);
  const { openDialog, objSousModuleDroit, valueEdit, valeurComboEdit } = useSelector((state: IReduxState) => state.sousModuleDroit);
    
  

  //hooks
  const [valueSousModuleDroit, setValueSousModuleDroit] = useState("");
  const [openAlert, setOpenAlert] = useState(false);

  const handleSave = async () => {
    try {
      const apiPayload = {
        idModuleDroit: objModuleDroit.idModuleDroit,
        libSousModuleDroit: valueSousModuleDroit,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/creersousmoduledroit",
        apiPayload
      );
      if (res.status === 1) {
        const newSousModuleDroit = {
          ...res.data,
          id: res.data.idSousModuleDroit,
          libelle: res.data.libSousModuleDroit,
        };
        dispatch(addSousModuleDroits(newSousModuleDroit));
        dispatch(setOpenDialog(false));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: AddSousModuleDroit.tsx ~ line 51 ~ handleSave ~ error",
        error
      );
    }
  };

  const editItem = async () => {
    try {
      const apiPayload = {
        idModuleDroit: objSousModuleDroit.idModuleDroit,
        idSousModuleDroit: objSousModuleDroit.idSousModuleDroit,
        libSousModuleDroit: valueEdit,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/modifiersousmoduledroit",
        apiPayload
      );
      if (res.status === 1) {
        const newSousModuleDroit = {
          ...res.data,
          id: res.data.idSousModuleDroit,
          libelle: res.data.libSousModuleDroit,
        };
        dispatch(editSousModuleDroit(newSousModuleDroit));
        dispatch(setOpenDialog(false));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error",
        error
      );
    }
  };

  const handleOpen = () => {
    //verifier si un module a été selectionné avant d'ouvir le dialog d'enreegistrement du sous module
    if (Object.keys(objModuleDroit).length > 0) {
      dispatch(setOpenDialog(true));
      dispatch(setObjSousModuleDroit({}));
      setValueSousModuleDroit("");
    } else {
      setOpenAlert(true);
    }
  };

  const handleClose = () => {
    dispatch(setOpenDialog(false));
  };

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  return (
    <div>
      <MyDialogComponent
        dialogTitle={`${
          Object.keys(objSousModuleDroit).length > 0
            ? `Modifier ${objSousModuleDroit.libSousModuleDroit}`
            : `Créer un sous module`
        }`}
        // dialogTitle={`${Object.keys(objSousModuleDroit).length > 0 ? "Modifier" + " " + objSousModuleDroit.libelleSousModuleDroit : "Créer un sous module"}`}
        dialogContent={
          Object.keys(objSousModuleDroit).length > 0 ? (
            <EditForm
              setValueEdit={setValueEdit}
              valueEdit={valueEdit}
              setValueComboEdit={setValueComboEdit}
              valeurComboEdit={valeurComboEdit}
              data={moduleDroits}
              libelle="Sous module"
              libelleCombo="Module"
            />
          ) : (
            <Formulaire
              setValueSousModuleDroit={setValueSousModuleDroit}
              valueSousModuleDroit={valueSousModuleDroit}
            />
          )
        }
        handleSave={
          Object.keys(objSousModuleDroit).length > 0 ? editItem : handleSave
        }
        openDialog={openDialog}
        handleClose={handleClose}
        handleOpen={handleOpen}
      />
      <CommonAlert
        severity="warning"
        variant="filled"
        description="Veuillez selectionner un module."
        title="Alerte !"
        openAlert={openAlert}
        handleAlertClose={handleAlertClose}
      />
    </div>
  );
};

export default AddSousModuleDroit;
